import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-producer-confirmation-popup',
  templateUrl: './producer-confirmation-popup.component.html',
  styleUrls: ['./producer-confirmation-popup.component.scss']
})
export class ProducerConfirmationPopupComponent implements OnInit {

  constructor(private commonService: CommonService) {
  }

  ngOnInit(): void {
  }

  closingActionPerform(sendType:any) {
    this.commonService.closingPopupWithSendData(sendType);
  }

  closeByDeviceType() {
      this.commonService.closingPopupWithSendData('redirect-dashboard');
  }

}
